import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m61.59 46.6-11.586-4.968a3.983 3.983 0 0 0-4.64 1.128l-4.396 5.373a36.91 36.91 0 0 1-16.1-16.101l5.372-4.396a3.983 3.983 0 0 0 1.128-4.64L26.4 11.401a3.976 3.976 0 0 0-4.548-2.3l-10.778 2.493A3.934 3.934 0 0 0 8 15.46C8 42.777 30.223 65 57.54 65a3.963 3.963 0 0 0 3.874-3.09l2.484-10.762a3.975 3.975 0 0 0-2.299-4.54l-.008-.008ZM19.058 30.735l.21.447c5.247 11.19 11.36 17.296 22.552 22.55l.446.211 6.374-7.797 10.56 4.522-2.223 9.642C32.7 60.014 12.986 40.3 12.7 16.032l9.642-2.223 4.522 10.56-7.798 6.375-.008-.009Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "phone"}) } }